import React, { useState } from 'react'
import ProjectRecommendManagement from '../components/ProjectRecommendManagement/ProjectRecommendManagement'

const PageProjectRecommendManagement = () => {
  return (
    <>
      <ProjectRecommendManagement></ProjectRecommendManagement>
    </>
  )
}

export default PageProjectRecommendManagement
